import React, { useContext } from 'react';
import { Route, Navigate } from 'react-router-dom';
import { authContext } from './Login/AuthContext';


function validToken(token, setAuthData){
    fetch ('https://mel.dvrc.fr/api/tokenValidity.php', {
			method: 'POST',
			body: JSON.stringify({'token': token}),
			headers: {"Content-type": "application/json; charset=UTF-8"}
		})
        .then(res => res.json())
        .then((data) => {
          if(!data.valid)
            setAuthData(null);
        }).catch(console.log)
  };

const PrivateRoute = ({ children}) => {
  const { auth } = useContext(authContext);
  const { loading } = auth;
  const { setAuthData } = useContext(authContext);

  if (auth.data){
    validToken(auth.data.token, setAuthData);
  }

  if (auth.data) return children;
  return <Navigate to="/Login/Login" replace/>
}

export default PrivateRoute;
